import { ComponentStyleConfig } from '@chakra-ui/react';

const Popover: ComponentStyleConfig = {
  baseStyle: {
    lineHeight: '26px',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};

export default Popover;
